import React, { Fragment, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { ChromePicker } from 'react-color';

import Button from '../../../../../../../../components/global/Button';
import FormGroup from '../../../../../../../../components/global/FormGroup';
import useClickOutside from '../../../../../../../../hooks/useClickOutside';
import InputGroup from '../../../../../../../../components/global/InputGroup';

const propTypes = {
  text: PropTypes.string,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  onInsertTickerTape: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};
const TickerTapeInsert = ({
  text,
  color,
  backgroundColor,
  onInsertTickerTape,
  onRequestClose,
}) => {
  const colorRef = useRef(null);
  const bgColorRef = useRef(null);
  const [currentText, setCurrentText] = useState(text);
  const [currentColor, setCurrentColor] = useState(color ?? '#000000');
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const [currentBackgroundColor, setCurrentBackgroundColor] = useState(
    backgroundColor ?? '#FFFFFF',
  );
  const [
    displayBackgroundColorPicker,
    setDisplayBackgroundColorPicker,
  ] = useState(false);
  const [saving, setSaving] = useState(false);

  useClickOutside(colorRef, () => {
    setDisplayColorPicker(false);
  });

  useClickOutside(bgColorRef, () => {
    setDisplayBackgroundColorPicker(false);
  });

  const onDone = async () => {
    if (saving) {
      return;
    }

    setSaving(true);
    await onInsertTickerTape({
      message: currentText,
      color: currentColor,
      backgroundColor: currentBackgroundColor,
    });
    setSaving(false);
    onRequestClose();
  };

  return (
    <Fragment>
      <FormGroup
        id="message"
        type="textarea"
        label="Message"
        value={currentText}
        onChange={event => {
          const { target } = event;
          setCurrentText(target.value);
        }}
      />

      <div className="d-flex flex-column flex-md-row">
        <InputGroup
          id="text-color"
          value={currentColor}
          label="Text Color"
          wrapperRef={colorRef}
          wrapperClassName="slideshow-designer-color-control mr-md-1"
          onClick={() => setDisplayColorPicker(true)}
          readOnly
          addon={
            <Fragment>
              <div
                aria-hidden
                role="button"
                className="slideshow-designer-color-control-addon"
                style={{ backgroundColor: currentColor }}
                onClick={() => setDisplayColorPicker(true)}
              />
              {displayColorPicker ? (
                <div className="slideshow-designer-color-control-popover">
                  <ChromePicker
                    color={currentColor}
                    onChange={value => setCurrentColor(value.hex)}
                    onChangeComplete={value => {
                      setCurrentColor(value.hex);
                    }}
                    width="100%"
                    disableAlpha
                  />
                </div>
              ) : null}
            </Fragment>
          }
        />
        <InputGroup
          id="background-color"
          value={currentBackgroundColor}
          label="Background Color"
          wrapperRef={bgColorRef}
          wrapperClassName="slideshow-designer-color-control ml-md-1"
          onClick={() => setDisplayBackgroundColorPicker(true)}
          readOnly
          addon={
            <Fragment>
              <div
                aria-hidden
                role="button"
                className="slideshow-designer-color-control-addon"
                style={{ backgroundColor: currentBackgroundColor }}
                onClick={() => setDisplayBackgroundColorPicker(true)}
              />
              {displayBackgroundColorPicker ? (
                <div className="slideshow-designer-color-control-popover">
                  <ChromePicker
                    color={currentBackgroundColor}
                    onChange={value => setCurrentBackgroundColor(value.hex)}
                    onChangeComplete={value => {
                      setCurrentBackgroundColor(value.hex);
                    }}
                    width="100%"
                    disableAlpha
                  />
                </div>
              ) : null}
            </Fragment>
          }
        />
      </div>
      <p className="text-light text-sm text-center">
        Note: You may tap on the ticker tape banner to customize these settings
        anytime.
      </p>
      <div className="text-center">
        <Button onClick={onDone} disabled={saving}>
          {saving ? 'Saving...' : 'Insert'}
        </Button>
      </div>
    </Fragment>
  );
};

TickerTapeInsert.propTypes = propTypes;

export default TickerTapeInsert;
